export default __webpack_public_path__ + "static/media/sales.ea0c58ec.svg";